import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: 30 },
  header: {
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  inputsProviderConnections: {
    display: 'grid',
    gridTemplateColumns: '1fr 0.1fr 1fr 0.1fr 1fr 0.1fr 1fr',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  iconButton: { marginRight: '34px' },
  title: {
    marginBottom: 30,
    marginTop: 30
  },
  mainCheckBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  availabilitySection: {
    display: 'flex',
    flexDirection: 'column'
  },
  ratesSection: {
    display: 'flex',
    flexDirection: 'column'
  },
  restrictionSection: {
    display: 'flex',
    flexDirection: 'column'
  },
  bookingSection: {
    display: 'flex',
    flexDirection: 'column'
  },
  lineSection: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: '20px'
    }
  },
  lineSectionContainer: {
    width: '1px',
    border: `1px dashed${theme.palette.grey[400]}`,
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))
export default useStyles
